export default __webpack_public_path__ + "static/media/SpendInStoreOnline.345c7bb1.svg";